<template>
  <div class="NotFound">
    <div class="img">
      <img src="@/assets/404.png" alt="" />
    </div>
    <h3>糟糕，页面迷路了</h3>
    <span>你访问的页面可能已失效或被删除</span>
    <div class="back">
      <el-button type="primary" @click="$router.push('/')">返回首页</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  activated() {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.NotFound {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  width: 100%;
  height: 100%;
  background: #fff;
  .img {
    width: 420px;
    height: 200px;
    img {
      width: 420px;
      height: 200px;
    }
  }
  h3 {
    margin-bottom: 12px;
    font-size: 24px;
    font-weight: 500;
    color: #262626;
  }
  span {
    font-size: 14px;
    color: #8a8f8d;
  }
  .back{
    margin-top: 20px;
    margin-bottom: 100px;
  }
}
</style>
